import Toggle from "components/Atoms/Toggle"
import { useUpdateDcMutation } from "generated/graphql"
import React from "react"
import AppToaster from "utils/AppToaster"
import useDCStore from "./dc.store"

const DCRegistrationActions = () => {
  const dcId = useDCStore(store => store.state.basicDetails.id)
  const archived = useDCStore(store => store.state.basicDetails.archive)
  const [toggle] = useUpdateDcMutation({
    onCompleted({ updateDistributionCentre: { distributionCentre: dc } }) {
      AppToaster.show({
        intent: "success",
        message: `${dc.properties.name} is now ${
          dc.properties.archive ? "archived" : "active"
        }`,
      })
    },
  })

  return (
    <>
      <Toggle
        intent="success"
        checked={!archived}
        onClick={() => {
          toggle({ variables: { archive: !archived, id: dcId } })
        }}
        innerLabel={archived ? "Archived" : "Active"}
      />
    </>
  )
}

export default DCRegistrationActions
